import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Typography, Box } from '@mui/material'
import { ArrowDropDown } from '@mui/icons-material'

interface CustomAccordionProps {
  title: string
  children: React.ReactNode
  defaultExpanded?: boolean
}

const CustomAccordion: React.FC<CustomAccordionProps> = ({
  title,
  children,
  defaultExpanded = false,
}) => {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      sx={{
        backgroundColor: '#fff',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        marginBottom: '16px',
      }}
    >
      <AccordionSummary
        expandIcon={<ArrowDropDown />}
        aria-controls={`${title}-content`}
        id={`${title}-header`}
      >
        <Typography variant='body1' color='secondary'>
          <strong>{title}</strong>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box>{children}</Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default CustomAccordion
